export const Header = {
	APPLICATION_JSON: "application/json",
	APPLICATION_XML: "application/xml",
	TEXT_JSON: "text/json",
	JSON: "JSON",
} as const;

export type HeaderType = (typeof Header)[keyof typeof Header];
